/// <reference path="../../app.definition.ts" />

/*
* eCareVault.IEnterpriseService
* author: Ian Tripp
*/
import angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
export interface IEnterpriseService {
    hasForms(): any;
    hasViewOnly(): boolean;
    hasServices(): boolean;
    has(service: string): boolean;
    hasSignature(): boolean;
    isEnterprise(): any;
    init();
}

export class EnterpriseService implements IEnterpriseService {
    svcName: string = 'eCareVault.EnterpriseService';

    features: {
        forms: boolean,
        viewOnly: boolean,
        services: boolean,
        signature: boolean,
        analytics: boolean,
        combineDocument: boolean,
        quickAssignAndFillForm: boolean,
        customAttributes: boolean,
        clientDashboard: boolean,
        multipleTeam: boolean,
        customSubjectSearch: boolean,
        //Add new enterPrise feature as youTube video links.
        links: boolean,
        globalDashboard: boolean
    } = {
            forms: false,
            viewOnly: false,
            services: false,
            signature: false,
            analytics: false,
            combineDocument: false,
            quickAssignAndFillForm: false,
            customAttributes: false,
            clientDashboard: false,
            multipleTeam: false,
            customSubjectSearch: false,
            links: false,
            globalDashboard: false
        }

    static $inject = ["ApiAdapterService", "CacheService", "$q"];
    constructor(
        private $_api: JavaApiAdapterService,
        private $_cache: CacheService,
        private $q
    ) {
    }

    hasForms = (): any => {
        var deferred = this.$q.defer();
        this.loadEnterpriseFeatures().then((s) => {
            deferred.resolve(true);
        });
        return deferred.promise;
    }
    hasViewOnly = (): boolean => !!this.features.viewOnly;
    hasServices = (): boolean => !!this.features.services;
    hasSignature = (): boolean => !!this.features.signature;
    has = (service: string): boolean => !!this.features[service];

    init = (): any => {
        var deferred = this.$q.defer();
        this.loadEnterpriseFeatures().then((s) => {
            deferred.resolve(true);
        });
        return deferred.promise;
    }

    loadEnterpriseFeatures = (): any => {
        var deferred = this.$q.defer();
        if (!!this.$_cache.getFeatures()) {
            deferred.resolve(true);
        } else {
            this.$_api.enterpriseFeatures().then(
                (s: any) => {
                    this.features.forms = !!s.forms;
                    this.features.viewOnly = !!s.viewOnly;
                    this.features.services = !!s.services;
                    this.features.signature = !!s.signature;
                    this.features.analytics = !!s.analytics;
                    this.features.combineDocument = !!s.combineDocument;
                    this.features.quickAssignAndFillForm = !!s.quickAssignAndFillForm;
                    this.features.customAttributes = !!s.customAttributes;
                    this.features.clientDashboard = !!s.clientDashboard;
                    this.features.multipleTeam = !!s.multipleTeam;
                    this.features.customSubjectSearch = !!s.customSubjectSearch;
                    this.features.links = !!s.links;
                    this.features.globalDashboard = !!s.globalDashboard;
                    this.$_cache.setFeatures(this.features);
                    deferred.resolve(true);
                }
            )
        }
        return deferred.promise;
    }

    isEnterprise = (): any => {
        var deferred = this.$q.defer();
        if (!!this.$_cache.getUserPlanType()) {
            deferred.resolve(true);
        } else {
            this.$_api.getCurrentSubscribePlanForUser(false).then(
                (s: any) => {
                    this.$_cache.setUserPlanType(s.planType);
                    deferred.resolve(true);
                }
            )
        }
        return deferred.promise;
    }


}
angular.module('eCareVault.common.services')
    .service('EnterpriseService', EnterpriseService);

